import { render, staticRenderFns } from "./Hi.vue?vue&type=template&id=5a0fdc16&scoped=true&"
import script from "./Hi.vue?vue&type=script&lang=js&"
export * from "./Hi.vue?vue&type=script&lang=js&"
import style0 from "./Hi.vue?vue&type=style&index=0&id=5a0fdc16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0fdc16",
  null
  
)

export default component.exports